import dayjs from "dayjs";

/* The day runs 6am to 6am rather than midnight to midnight: a sale entered at
   1am belongs to the day that started the previous morning, which is the day
   the person entering it would call it. The clock time is kept and only the
   date moves back.
 *
 * Deliberately the entering device's own local time, not the salon's. The date
 * in the box beside the Enter button is the single source of truth: whatever it
 * says is what gets stored, with no conversion in between, so data entry is not
 * tied to one part of the world. The accepted cost is that two people entering
 * from different timezones on the same night could file it under different
 * dates.
 *
 * This used to be applied here and then quietly undone on the server, which
 * re-derived the date from the timestamp in its own timezone -- a sale entered
 * at 14:32 in New York was filed under the following day in Bangkok and
 * disappeared from the running total. The server keeps the rule now only as a
 * fallback for a request that does not say which day it means. */
const BUSINESS_DAY_STARTS_AT = 6;

export const businessDate = (at = dayjs()) => {
    const moment = dayjs(at);
    return moment.hour() < BUSINESS_DAY_STARTS_AT
        ? moment.subtract(1, "day")
        : moment;
};

/* The two strings the server files a record under. Sent rather than derived
   there, so what is stored is what was on the screen. */
export const asDayString = at => dayjs(at).format("YYYY-MM-DD");

export const asTimeString = (at = dayjs()) => dayjs(at).format("HH:mm");

/* sliced off the day rather than formatted separately, so a record cannot end
   up in a month its own day does not fall in */
export const asMonthString = at => asDayString(at).slice(0, 7);

export const businessDay = (at = dayjs()) => asDayString(businessDate(at));

export const mergeState = (state, object) => {
    return {
        ...state,
        ...object,
    };
};
